import BForm from './packages/BForm'

BForm.install = function(Vue) {
    Vue.component(BForm.name, BForm)
}

export default BForm
